import _ from 'lodash';

import { requestApi } from './Api';

export const createInstantPacket = async (navigate, params, options = {}) => {
  return requestApi({
    navigate,
    url: '/api/form/instant_packet/create',
    params,
    onError: () => {},
    ...options
  });
};

export const getPracticeInstantPacket = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/practice/practice_i_queue/instant_packet/get',
    params
  });
};
